import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import * as authApi from '@/api/auth';
import type { LoginRequest } from '@/types/auth';

export function useAuth() {
  const { user, isAuthenticated, setAuth, clearAuth, getUserDisplayName } =
    useAuthStore();
  const navigate = useNavigate();

  const login = useCallback(
    async (credentials: LoginRequest) => {
      const response = await authApi.login(credentials);
      setAuth(response.access_token, response.user, response.expires_at);
      navigate('/', { replace: true });
    },
    [setAuth, navigate]
  );

  const logout = useCallback(async () => {
    await authApi.logout();
    clearAuth();
    navigate('/login', { replace: true });
  }, [clearAuth, navigate]);

  return {
    user,
    isAuthenticated,
    login,
    logout,
    displayName: getUserDisplayName(),
  };
}
